import { Injectable, InjectionToken, inject } from '@angular/core';

import { DesignerSuiteService } from '../modules/designer/service/designer-suite.service';
import {
    OpenTabEntry,
    ParentContext,
    closeAndNotifyParent,
    ensureWindowName,
    getParentContext,
} from '../utility/child-tab-close';

export const WINDOW = new InjectionToken<Window>('WINDOW', {
    factory: () => globalThis as unknown as Window,
});

@Injectable({
    providedIn: 'root',
})
export class TabCloseService {
    beforeClose: (() => void) | null = null;
    currentWindow: Window = inject(WINDOW);
    designerSuiteService = inject(DesignerSuiteService);
    isChildWindow: boolean = false;
    landingPageUrl = import.meta.env.NG_APP_LANDING_PAGE_URL;
    openTabs: OpenTabEntry[] = [];
    parentWindow: Window | null = null;

    closeTab() {
        if (this.beforeClose) {
            this.beforeClose();
            return;
        }
        this.forceCloseTab();
    }

    forceCloseTab() {
        const projectDetails = this.designerSuiteService.getData() as any;

        // 1. Try to get ID from Service Data
        // 2. Fallback: Parse it from the current URL (the last segment)
        const urlSegments = this.currentWindow.location.pathname.split('/');
        const idFromUrl = urlSegments.at(-1);

        const hubIdentifier = projectDetails?.instance_id || idFromUrl;

        console.debug(
            '[TAB-CLOSE] Closing tab. Notifying Hub with ID:',
            hubIdentifier
        );

        const parentContext: ParentContext = getParentContext(
            this.currentWindow,
            this.getRedirectToScenarioURL()
        );

        closeAndNotifyParent(
            this.currentWindow,
            parentContext,
            this.parentWindow,
            this.getRedirectToScenarioURL(),
            hubIdentifier
        );
    }

    getRedirectToScenarioURL(): string {
        const projectDetails = this.designerSuiteService.getData() as any;
        return `${this.landingPageUrl}/app/project/landing/${projectDetails.project_id}/${projectDetails.scenario_id}?element_id=${projectDetails.element_id}`;
    }

    init() {
        const parentContext: ParentContext = getParentContext(
            this.currentWindow,
            this.getRedirectToScenarioURL()
        );
        const { isChildWindow, parentWindow } = parentContext;
        if (isChildWindow) {
            this.isChildWindow = true;
            this.parentWindow = parentWindow;
        }
        ensureWindowName(this.currentWindow);
    }
}
